import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "../../assets/logo.png";

export const PublicHeader = ({ rightContent, clinicId }) => (
  <AppBar
    position="static"
    elevation={0}
    sx={{
      bgcolor: "#fff",
      borderBottom: "3px solid",
      borderColor: "primary.main",
    }}
  >
    <Toolbar sx={{ justifyContent: "space-between", px: { xs: 2, md: 4 } }}>
      <a href={`/${clinicId}/me`} style={{ textDecoration: "none" }}>
        <Box component="img" src={Logo} alt="Jagendo" sx={{ height: { xs: 32, md: 40 } }} />
      </a>
      <Stack direction="row" alignItems="center" spacing={2}>
        {rightContent && (
          typeof rightContent === "string"
            ? <Typography variant="body1" sx={{ color: "text.secondary" }}>{rightContent}</Typography>
            : rightContent
        )}
      </Stack>
    </Toolbar>
  </AppBar>
);
